import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/usuarioCadastro/';

class UsuarioService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    getUsuarioByCpf(cpf, idCliente, idConta) {
        return axios.get(API_URL + 'searchByCpf?cpf=' + cpf + '&idCliente=' + idCliente + '&idConta=' + idConta, { headers: this.headers }).then(response => (this.data = response.data));
    }

    save(usuarioCadastro) {
        console.log(JSON.stringify(usuarioCadastro));
        return axios.post(API_URL, JSON.stringify(usuarioCadastro),
            { headers: this.headers });
    }

    remove(idCliente, usuarioAcessoId, idContribuinte) {
        return axios.delete(API_URL + 'delete?idCliente=' + idCliente + '&usuarioAcessoId=' + usuarioAcessoId + '&idContribuinte=' + idContribuinte, { headers: this.headers });
    }

    removeUsuarioContribuinte(idCliente, usuarioAcessoId, idUsuarioContribuinte, idContribuinte) {
        return axios.delete(API_URL + 'deleteUsuarioContribuinte?idCliente=' + idCliente + '&usuarioAcessoId=' + usuarioAcessoId + '&idUsuarioContribuinte=' + idUsuarioContribuinte + '&idContribuinte=' + idContribuinte, { headers: this.headers });
    }

    salvarUsuarioMaster(idUsuario, master) {
        return axios.post(API_URL + 'saveUsuarioMaster?idUsuario=' + idUsuario + '&master=' + master, null, { headers: this.headers });
    }

    salvarUsuarioMasterFiscal(idUsuario, master) {
        return axios.post(API_URL + 'saveUsuarioMasterFiscal?idUsuario=' + idUsuario + '&master=' + master, null, { headers: this.headers });
    }

}

export default new UsuarioService();